<template>
    <div id="toggle" @click="toggleDashboard()">
        <md-tooltip md-direction="bottom" v-if="!dashMaximized">Maximize dashboard</md-tooltip>
        <md-tooltip md-direction="bottom" v-else>Minimize dashboard</md-tooltip>
        <span v-if="!dashMaximized" class="material-icons">open_in_full</span>
        <span v-else class="material-icons">close_fullscreen</span>
    </div>
</template>

<script>
export default {
    methods: {
        toggleDashboard(){
            this.dashMaximized  = !this.dashMaximized;
        }
    },
    computed: {
        dashMaximized:{
            get(){
                return this.$store.getters['dashboard/isDashMaximized'];
            },
            set(isMaximized){
                this.$store.commit('dashboard/setDashMaximized', isMaximized);
            }
        },
    }
}
</script>

<style>
#toggle {
    margin: 15px;
    max-width: 30px;
    max-height: 30px;
    padding: 4px;
    border-radius: 4px;
}
#toggle:hover {
    cursor: pointer;
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
}

@media screen and (max-width: 375px) {
    #toggle {
        display: none;
    }
}
</style>